type ReplaceableCollection<T> = {
    bulkPut(values: T[]): Promise<void>
    findAll(): Promise<T[]>
    remove(id: string): Promise<void>
}

export async function replacePersistedCollection<T>(
    collection: ReplaceableCollection<T>,
    values: T[],
    getKey: (value: T) => string,
    signal?: AbortSignal
): Promise<void> {
    if (signal?.aborted) {
        return
    }

    const nextKeys = new Set(values.map(getKey))
    const existingValues = await collection.findAll()

    if (signal?.aborted) {
        return
    }

    await collection.bulkPut(values)

    if (signal?.aborted) {
        return
    }

    await Promise.all(
        existingValues
            .filter((value) => !nextKeys.has(getKey(value)))
            .map(async (value) => {
                await collection.remove(getKey(value))
            })
    )
}
